module.exports = __webpack_public_path__ + "static/ogimage-14eb3845b438cc2abc8119efacfc3ab6.png";